import React from 'react'
import styled from "./SideDiv1.module.css"
const SideDiv2 = () => {
  return (
    <div className={styled.div1}>
      <h4>Get best matched jobs directly in your mail.</h4>
      <p>Tell us what kind of a job you are looking out for and stay updated with latest opportunities.</p>
      <div>No registration required!</div>
      <button className={styled.btn1}>Create Job Alert</button>
    </div>
  )
}

export default SideDiv2
